import React from 'react';
import I18n from 'i18n-js';

import { ModalConfirmation } from '@reverbdotcom/commons/src/components/modal_confirmation';
import { connect } from '@reverbdotcom/commons/src/connect';
import * as elog from '@reverbdotcom/commons/src/elog';

import { DeleteMyFavoriteMutationFn, useDeleteMyFavorite, withDeleteMyFavoriteMutation } from './delete_my_favorite_mutation';
import { useFindFavorite, FavoriteModal } from './find_favorite_context';

interface MutationProps {
  deleteMyFavorite: DeleteMyFavoriteMutationFn;
}

interface ExternalProps {
  handleRemove: () => void;
}

type Props = ExternalProps & MutationProps;

export function InternalRemoveFavoriteModal(props: Props) {
  const { favorite, displayedModal, setDisplayedModal, setIsToastOpen } = useFindFavorite();
  const { deleteMyFavorite } = useDeleteMyFavorite(props.deleteMyFavorite, favorite.id);

  const deleteFavorite = async function () {
    try {
      await deleteMyFavorite();
      setDisplayedModal(FavoriteModal.None);
      setIsToastOpen(true);
      props.handleRemove();
    } catch (e) {
      elog.error(
        e.message,
        { componentName: 'RemoveFavoriteModal' },
        e,
      );
    }
  };

  return (
    <ModalConfirmation
      isOpen={displayedModal === FavoriteModal.Remove}
      title={I18n.t('discovery.favorites.deleteConfirmationModal.search.title')}
      content={I18n.t('discovery.favorites.deleteConfirmationModal.content', { title: favorite.title })}
      confirmButtonText={I18n.t('discovery.favorites.deleteConfirmationModal.confirmButtonText')}
      onConfirm={deleteFavorite}
      onRequestClose={() => setDisplayedModal(FavoriteModal.None)}
    />
  );
}

export const RemoveFavoriteModal = connect<ExternalProps>([
  withDeleteMyFavoriteMutation,
])(InternalRemoveFavoriteModal);
